import l from "react";
import { cx as o } from "@huspy/styled-system/css";
function a({
  children: t,
  ...e
}) {
  return l.isValidElement(t) ? l.cloneElement(t, {
    ...e,
    ...t.props,
    style: {
      ...e.style,
      ...t.props.style
    },
    className: o(e.className, t.props.className)
  }) : (l.Children.count(t) > 1 && l.Children.only(null), null);
}
export {
  a as Slot
};
